export default "__VITE_ASSET__ChKAEPxS__"